import { z } from 'zod'

const url = z.url()

const envSchema = z.object({
  VITE_AUTH0_DOMAIN: z.string().min(1),
  VITE_AUTH0_CLIENT_ID: z.string().min(1),
  VITE_AUTH0_AUDIENCE: z.string().min(1),
  VITE_SUPPLIER_CLASSIFICATION_API_BASE_URL_ACCEPTANCE: url,
  VITE_SUPPLIER_CLASSIFICATION_API_BASE_URL_PRODUCTION: url,
  VITE_DATA_INGESTION_API_BASE_URL_ACCEPTANCE: url,
  VITE_DATA_INGESTION_API_BASE_URL_PRODUCTION: url,
  VITE_CONTEXT_HUB_API_BASE_URL_ACCEPTANCE: url,
  VITE_CONTEXT_HUB_API_BASE_URL_PRODUCTION: url,
  VITE_CHRONOS_API_BASE_URL_ACCEPTANCE: url,
  VITE_CHRONOS_API_BASE_URL_PRODUCTION: url,
  VITE_ENRICHMENT_CATEGORIZATION_API_BASE_URL_ACCEPTANCE: url,
  VITE_ENRICHMENT_CATEGORIZATION_API_BASE_URL_PRODUCTION: url,
  VITE_ENRICHMENT_PAYMENT_TERMS_API_BASE_URL_ACCEPTANCE: url,
  VITE_ENRICHMENT_PAYMENT_TERMS_API_BASE_URL_PRODUCTION: url,
  VITE_ENRICHMENT_SUPPLIER_NORMALIZATION_API_BASE_URL_ACCEPTANCE: url,
  VITE_ENRICHMENT_SUPPLIER_NORMALIZATION_API_BASE_URL_PRODUCTION: url,
  VITE_APP_BASE_URL_ACCEPTANCE: url,
  VITE_APP_BASE_URL_PRODUCTION: url,
})

const parsed = envSchema.safeParse(import.meta.env)

if (!parsed.success) {
  throw new Error(
    `Invalid environment configuration — check your .env file:\n${z.prettifyError(parsed.error)}`,
  )
}

export const env = parsed.data
